import ActionButton from "../components/tableActions/tableActions.component";
import { actionsButtonsContainerSx } from "../styles/commonStyles";

export const createRowsData = (nameField) => (data) => ({
  id: data?.id,
  [nameField]: data?.name,
});

export const createGenericColumns = ({
  nameField,
  nameHeader,
  actions,
  nameMinWidth = 200,
}) => [
  { field: "id", headerName: "ID" },
  {
    field: nameField,
    headerName: nameHeader,
    flex: 0.1,
    minWidth: nameMinWidth,
  },
  {
    field: "actions",
    headerName: "Azioni",
    flex: 0.06,
    minWidth: 100,
    renderCell: (params) => (
      <div style={actionsButtonsContainerSx}>
        {actions.map((item, index) => (
          <ActionButton
            key={index}
            icon={item.icon}
            tooltip={item.tooltip}
            onClick={() => item.onClick(params.row.id)}
          />
        ))}
      </div>
    ),
  },
];
